<template>
	<Table ref="tableObj" :columns="columns" :data="tableData" :row-key="true" :height="tableHeight" size="small" :loading="tableLoading" @on-expand="handleToggleExpand">
		<div slot="footer">
			<!-- <MyPage :param="pageParam" :url="url"></MyPage> -->
			<Page v-show="show" class="page" @on-page-size-change="totalPageChange" :page-size="pageSize"
				:page-size-opts="opts" :total="pageTotal" size="small" show-elevator show-sizer @on-change="pageChange"
				:current="currentPage" />
		</div>
	</Table>
</template>

<script>
	export default {
		props: ['columns', 'tableHeight', 'url', 'queryParam'],
		data() {
			return {
				//分页属性
				pageTotal: 0,
				pageSize: 20,
				opts: [20, 100, 1000, 3000],
				currentPage: 1,
				show: true,
				tableLoading: false,
				tableData: [],
			};
		},
		methods: {
			pageChange: function(page) {
				console.log(page)
				this.currentPage = page;
				// this.pageTotal = this.getList();
				this.getData();
			},
			totalPageChange: function(a) {
				this.pageSize = a;
				// this.pageTotal = this.getList();
				this.getData();
			},
			getData: function(flag, onfinished) {
				const _this = this;
				const params = {
					..._this.queryParam,
					Page: _this.currentPage,
					PageSize: _this.pageSize,
				};

				this.tableLoading = true;
				this.pageTotal = 0;
				// const params = Object.assign(_this.param, params1);
				_this.$axios.post(_this.url, params).then(res => {
					if (res.data.Code == 0 || res.data.Code == 200) {
						_this.pageTotal = res.data.Total,
						_this.tableData = res.data.Data.List,
						// if(flag!=undefined){
						// 		_this.$emit(flag, res.data)
						// }else{
						// 	_this.$emit("listData", res.data)
						// }
						_this.$emit("onLoadData", res.data)
					}
				}).finally(res => {
					_this.tableLoading = false;
					if (onfinished) onfinished();
				});
			},
			exportCsv: function(cb) {
				const _this = this;
				if (cb) {
					const data = JSON.parse(JSON.stringify(_this.tableData));
					const exportOptions = {...cb(data), original: false, quoted: true};
					_this.$refs.tableObj.exportCsv(exportOptions);
				}
			},
			getSelection: function () {
				return this.$refs.tableObj.getSelection();
			},
			handleToggleExpand(row, expanded) {
				let originRow = this.tableData.find(item => item.Id === row.Id)
				// console.log('是否同一个对象：', originRow === row, originRow.Id, expanded, originRow._expanded)
				this.$emit("on-expand", originRow, expanded)
			}
		},
	}
</script>

<style scoped>
	.ivu-table-footer {
		border-top: 1px solid #e8eaec;
		padding: 0;
		margin: 0;
	}
</style>